import React from 'react';
import { GlobeIcon, InfinityIcon, LockIcon, ZapIcon } from 'lucide-react';
import { Section } from '../Section';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const lineItems = [{
  label: 'Renal Decision Desk™ — 6 Clinical Decision Volumes',
  value: '$97'
}, {
  label: 'Renal Red Flag Cards™',
  value: '$37'
}, {
  label: 'Renal Medication Decision Cards™',
  value: '$47'
}, {
  label: 'Renal Consultation Scripts™',
  value: '$27'
}, {
  label: 'The 25 Renal Decision Pitfalls™',
  value: '$47'
}, {
  label: 'Master Renal Visit Checklist™',
  value: '$37'
}];
const badges = [{
  Icon: ZapIcon,
  label: 'Instant digital delivery'
}, {
  Icon: InfinityIcon,
  label: 'Lifetime access'
}, {
  Icon: LockIcon,
  label: 'One-time payment, no subscription'
}];
export function Offer() {
  return <Section id="offer" tone="white" eyebrow="The complete offer" title="Everything you need to navigate common renal decisions through one structured system" data-id="element-222" data-mp="1pn8g4tzbd6g">
      <div className="mx-auto max-w-2xl overflow-hidden rounded-3xl border-2 border-ink/10 bg-cream shadow-[0_28px_60px_-34px_rgba(10,37,64,0.55)]" data-id="element-223" data-mp="1fmdfgx73u2au">
        <div className="bg-ink px-5 py-4 text-center sm:px-7" data-id="element-224" data-mp="1bll5u2ublve1">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-cyan-brand" data-id="element-225" data-mp="16lyszuiemh5r">
            What you receive
          </p>
        </div>

        <ul className="divide-y divide-ink-line px-5 sm:px-7" data-id="element-226" data-mp="23b6fp5urewb9">
          {lineItems.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-227" data-mp="1zb603hvxcf2m">
              <span className="text-[14px] font-semibold leading-snug text-ink" data-id="element-228" data-mp="1pkt7r3hvbhlx">
                {item.label}
              </span>
              <span className="shrink-0 text-[13.5px] font-bold text-ink-soft line-through" data-id="element-229" data-mp="2n10cxzg8u3mv">
                {item.value}
              </span>
            </li>)}
        </ul>

        <div className="border-t border-ink-line px-5 py-5 text-center sm:px-7" data-id="element-230" data-mp="314z36unx4df9">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-ink-soft" data-id="element-231" data-mp="364akq5w3zmxw">
            Total value
          </p>
          <p className="font-display text-3xl font-bold text-ink-soft line-through" data-id="element-232" data-mp="2sc464o8lto0k">
            $292
          </p>

          <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.18em] text-cta" data-id="element-233" data-mp="2wd7j92z9p5y3">
            Today just
          </p>
          <p className="font-display text-[68px] font-bold leading-none text-ink sm:text-[84px]" data-id="element-234" data-mp="2ihc5fbjq6l1k">
            $27
          </p>
          <p className="mt-2 text-[14px] font-semibold text-ink-soft" data-id="element-235" data-mp="29et4iwzi2ihy">
            You don’t pay $292. You don’t pay $97.
          </p>

          <div className="mt-5 flex flex-col items-center gap-2" data-id="element-236" data-mp="2dgepz6q3o53r">
            {badges.map(({
            Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-2 text-[13.5px] font-semibold text-ink" data-id="element-237" data-mp="7npx0gkwpk1m">
                <Icon className="h-4 w-4 text-cta" aria-hidden="true" data-id="element-238" data-mp="1w7lwy5m248is" />
                {label}
              </span>)}
          </div>

          <p className="mx-auto mt-5 flex max-w-md items-start gap-2.5 rounded-2xl border border-ink-line bg-white px-4 py-3 text-left text-[13px] font-medium leading-snug text-ink-soft" data-id="element-239" data-mp="1s2w3sois981k">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-cyan-brand" aria-hidden="true" data-id="element-240" data-mp="214c94huqqjyx" />
            <span data-id="element-241" data-mp="2avqgfbsxoo2m">
              <strong className="font-bold text-ink" data-id="element-242" data-mp="2aw9o7zovdw2x">
                Automatic currency conversion:
              </strong>{' '}
              the price is shown in USD and is automatically converted to your
              local currency at checkout.
            </span>
          </p>
        </div>

        <div className="px-5 pb-7 sm:px-7" data-id="element-243" data-mp="ugf63i650sfa">
          <ScarcityBar data-id="element-244" data-mp="uhgqid91mr9o" />
          <div className="mt-5" data-id="element-245" data-mp="pi5ax7kexrto">
            <CTAButton label="Yes — I want Renal Decision Desk™" sub="Get the complete system for $27 • Instant access • Lifetime access" data-id="element-246" data-mp="pix2m7aw35eo" />
            <CountdownTimer data-id="element-247" data-mp="vxumti0aukjh" />
          </div>
        </div>
      </div>
    </Section>;
}